import { useState } from "react";

function getNoticeUrl(noticeId) {
  return `${window.location.origin}/notices/${encodeURIComponent(noticeId)}`;
}

export default function NoticeShare({ notice }) {
  const [message, setMessage] = useState("");
  const url = getNoticeUrl(notice.id);
  const shareText = `${notice.title}\n${url}`;

  async function shareNotice() {
    setMessage("");
    if (typeof navigator.share === "function") {
      try {
        await navigator.share({
          title: notice.title,
          text: notice.content.slice(0, 220),
          url,
        });
      } catch (error) {
        if (error.name !== "AbortError") setMessage("साझा गर्न सकिएन।");
      }
      return;
    }

    try {
      if (!navigator.clipboard || !navigator.clipboard.writeText)
        throw new Error("Clipboard unavailable");
      await navigator.clipboard.writeText(url);
      setMessage("सूचनाको लिङ्क प्रतिलिपि भयो।");
    } catch {
      window.prompt("यो लिङ्क प्रतिलिपि गर्नुहोस्:", url);
      setMessage(
        "क्लिपबोर्ड उपलब्ध भएन। देखाइएको लिङ्क हातैले प्रतिलिपि गर्नुहोस्।",
      );
    }
  }

  return (
    <div className="notice-share">
      <button
        type="button"
        className="notice-share-button"
        onClick={shareNotice}
        aria-label={`“${notice.title}” साझा गर्नुहोस्`}
      >
        साझा गर्नुहोस्
      </button>
      <a
        className="notice-share-link"
        href={`https://wa.me/?text=${encodeURIComponent(shareText)}`}
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp मा साझा गर्नुहोस्"
      >
        WhatsApp
      </a>
      <a
        className="notice-share-link"
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
        target="_blank"
        rel="noreferrer"
        aria-label="Facebook मा साझा गर्नुहोस्"
      >
        Facebook
      </a>
      <span className="share-status" role="status" aria-live="polite">
        {message}
      </span>
    </div>
  );
}
